import React from 'react';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';

import studio1 from '../Images/About.jpg'
import studio2 from '../Images/LifeAtAD.jpg'
import studio3 from '../Images/Vacancies.jpg'
import studio4 from '../Images/EquityDiversity.jpg'
import studio5 from '../Images/corporateSocialResponsibilty.jpg'
import studio6 from '../Images/globalStudio.jpg'

const StudioSection = () => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    return (
        <div className="w-full px-4 md:px-14 text-white mb-14">
            <Link to='/studio'>
                <h1 className="text-4xl font-bold mb-8">Studio</h1>
            </Link>

            <div className="block md:hidden px-4">
                <Slider {...settings}>
                    <div className="relative rounded-lg overflow-hidden transition-transform duration-300 ease-in-out">
                        <Link to='/studio/about'>
                            <img
                                src={studio1}
                                alt="About"
                                className="w-full h-72 object-cover transition-transform duration-700 ease-in-out hover:scale-105"
                            />
                            <div className="absolute bottom-0 left-0 p-4 bg-gradient-to-t from-black to-slate-500/5 w-full">
                                <p className="text-white text-2xl font-semibold">About</p>
                            </div>
                        </Link>
                    </div>
                    <div className="relative rounded-lg overflow-hidden transition-transform duration-300 ease-in-out">
                        <Link to='careers/life-at-architetive-designs'>
                            <img
                                src={studio2}
                                alt="Life at Architetive Designs"
                                className="w-full h-72 object-cover transition-transform duration-700 ease-in-out hover:scale-105"
                            />
                            <div className="absolute bottom-0 left-0 p-4 bg-gradient-to-t from-black to-slate-500/5 w-full">
                                <p className="text-white text-2xl font-semibold">Life at Architetive Designs</p>
                            </div>
                        </Link>
                    </div>
                    <div className="relative rounded-lg overflow-hidden transition-transform duration-300 ease-in-out">
                        <Link to='careers/vacancies'>
                            <img
                                src={studio3}
                                alt="Vacancies"
                                className="w-full h-72 object-cover transition-transform duration-700 ease-in-out hover:scale-105"
                            />
                            <div className="absolute bottom-0 left-0 p-4 bg-gradient-to-t from-black to-slate-500/5 w-full">
                                <p className="text-white text-2xl font-semibold">Vacancies</p>
                            </div>
                        </Link>
                    </div>
                    <div className="relative rounded-lg overflow-hidden transition-transform duration-300 ease-in-out">
                        <Link to='people/equity-diversity-and-inclusion'>
                            <img
                                src={studio4}
                                alt="Equity, Diversity and Inclusion"
                                className="w-full h-72 object-cover transition-transform duration-700 ease-in-out hover:scale-105"
                            />
                            <div className="absolute bottom-0 left-0 p-4 bg-gradient-to-t from-black to-slate-500/5 w-full">
                                <p className="text-white text-2xl font-semibold">Equity, Diversity and Inclusion</p>
                            </div>
                        </Link>
                    </div>
                    <div className="relative rounded-lg overflow-hidden transition-transform duration-300 ease-in-out">
                        <Link to='/studio/corporate-social-responsibility'>
                            <img
                                src={studio5}
                                alt="Corporate Social Responsibility"
                                className="w-full h-72 object-cover transition-transform duration-700 ease-in-out hover:scale-105"
                            />
                            <div className="absolute bottom-0 left-0 p-4 bg-gradient-to-t from-black to-slate-500/5 w-full">
                                <p className="text-white text-2xl font-semibold">Corporate Social Responsibility</p>
                            </div>
                        </Link>
                    </div>
                    <div className="relative rounded-lg overflow-hidden transition-transform duration-300 ease-in-out">
                        <Link to='/studio'>
                            <img
                                src={studio6}
                                alt="Global Studios"
                                className="w-full h-72 object-cover transition-transform duration-700 ease-in-out hover:scale-105"
                            />
                            <div className="absolute bottom-0 left-0 p-4 bg-gradient-to-t from-black to-slate-500/5 w-full">
                                <p className="text-white text-2xl font-semibold">Global Studios</p>
                            </div>
                        </Link>
                    </div>
                </Slider>
            </div>

            <div className="hidden md:block">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
                    <div className="relative col-span-2 rounded-lg overflow-hidden transition-transform duration-300 ease-in-out">
                        <Link to='/studio/about'>
                            <img
                                src={studio1}
                                alt="Interior view of a modern office with large windows and desks"
                                className="w-full h-72 object-cover transition-transform duration-700 ease-in-out hover:scale-105"
                            />
                            <div className="absolute bottom-0 left-0 p-4 bg-gradient-to-t from-black to-slate-500/5 w-full">
                                <p className="text-white text-2xl font-semibold">About</p>
                            </div>
                        </Link>
                    </div>
                    <div className="bg-[#333333] p-6 flex items-center rounded-lg shadow-lg">
                        <p className="text-lg">
                            “We are a global studio for sustainable architecture, urbanism, engineering and design, founded in 2010.”
                            <br /><br />
                            <span className="font-bold tracking-wider">Architetive Designs</span>
                        </p>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
                    {[
                        { linkSrc: 'careers/life-at-architetive-designs', src: studio2, alt: "images", title: "Life at Architetive Designs" },
                        { linkSrc: 'careers/vacancies', src: studio3, alt: "images", title: "Vacancies" },
                        { linkSrc: 'people/equity-diversity-and-inclusion', src: studio4, alt: "images", title: "Equity, Diversity and Inclusion" }
                    ].map((item, index) => (
                        <div className="relative rounded-lg overflow-hidden transition-transform duration-300 ease-in-out" key={index}>
                            <Link to={`/${item.linkSrc}`}>
                                <img
                                    src={item.src}
                                    alt={item.alt}
                                    className="w-full h-full object-cover transition-transform duration-700 ease-in-out hover:scale-105"
                                />
                                <div className="absolute bottom-0 left-0 p-4 w-full bg-gradient-to-t from-black to-slate-500/10">
                                    <p className="text-white text-lg font-semibold">{item.title}</p>
                                </div>
                            </Link>
                        </div>
                    ))}
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    <div className="relative rounded-lg overflow-hidden transition-transform duration-300 ease-in-out">
                        <Link to='/studio/corporate-social-responsibility' className='h-full'>
                            <img
                                src={studio5}
                                alt="Images"
                                className="w-full h-72 object-cover transition-transform duration-700 ease-in-out hover:scale-105"
                            />
                            <div className="absolute bottom-0 left-0 p-4 w-full bg-gradient-to-t from-black to-slate-500/5">
                                <p className="text-white text-lg font-semibold">Corporate Social Responsibility</ p>
                            </div>
                        </Link>
                    </div>
                    <div className="col-span-2 relative rounded-lg overflow-hidden transition-transform duration-300 ease-in-out">
                        <Link to='/studio' className='h-full'>
                            <img
                                src={studio6}
                                alt="images"
                                className="w-full h-72 object-cover transition-transform duration-700 ease-in-out hover:scale-105"
                            />
                            <div className="absolute bottom-0 left-0 p-4 w-full bg-gradient-to-t from-black to-slate-500/5">
                                <p className="text-white text-lg font-semibold">Global Studios</p>
                            </div>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StudioSection;
